module.exports = __webpack_public_path__ + "img/icon_page_r_off.afe161bf.svg";